import { DistanceUnit } from "./shared/src/utils.js";
const toKm = (meters) => meters / 1e3;
const toMiles = (meters) => meters / 1609.344;
const hasDistance = (value) => "distance" in value && typeof value.distance === "number";
const formatDistance = (distance, distanceUnit, options) => {
  if (typeof distance !== "number" || distance === Infinity) {
    return "";
  }
  const separator = options?.separator || "";
  const hasPrecision = typeof options?.precision === "number";
  switch (distanceUnit) {
    case DistanceUnit.km:
      return `${Number(
        toKm(distance).toFixed(hasPrecision ? options?.precision : 1)
      )}${separator}km`;
    case DistanceUnit.mile:
      return `${Number(
        toMiles(distance).toFixed(hasPrecision ? options?.precision : 1)
      )}${separator}mi`;
    case DistanceUnit.meter:
      return `${Number(distance.toFixed(hasPrecision ? options?.precision : 0))}${separator}m`;
    default:
      console.warn(`Unknown distance unit ${distanceUnit}`);
      return distance.toFixed(hasPrecision ? options?.precision : 0);
  }
};
export {
  formatDistance,
  hasDistance,
  toKm,
  toMiles
};
//# sourceMappingURL=format-distance.js.map
